export const BabyNamesfaqs = {
  A: [
    [
      { name: "A'ishah", id: '2184' },
      { name: "A'marie", id: '3606' },
      { name: 'Aaaqil', id: '619' },
    ],
    [
      { name: 'Aabroo', id: '5878' },
      { name: 'Aabida', id: '1981' },
      { name: 'Aadir', id: '698' },
    ],
    [
      { name: 'Aadne', id: '1594' },
      { name: 'Aaget', id: '2440' },
      { name: 'Aapo', id: '6956' },
    ],
    [
      { name: 'Abd al Alim', id: '10615' },
      { name: 'Abd al Bari', id: '11091' },
      { name: 'Abd al Hakim', id: '6537' },
      { name: 'Abd al Jabbar', id: '7035' },
      { name: 'Abd al Matin', id: '8845' },
    ],
    [{ name: 'aanifatimahkhatoon', id: '1641' }],
    [
      { name: 'Aar', id: '1135' },
      { name: 'Aan', id: '2216' },
      { name: 'Aad', id: '1157' },
      { name: 'Aas', id: '1269' },
    ],
  ],
  B: [
    [
      { name: 'babay', id: '12069' },
      { name: 'babe', id: '16367' },
      { name: 'barbetta', id: '13001' },
      { name: 'babi', id: '13448' },
    ],

    [
      { name: 'baako', id: '11701' },
      { name: 'baani', id: '11548' },
      { name: 'baano', id: '13425' },
      { name: 'babo', id: '14170' },
    ],

    [
      { name: 'barbetta', id: '13001' },
      { name: 'bacchus', id: '11962' },
      { name: 'badane', id: '14037' },
    ],
    [
      { name: 'Beau', id: '14473' },
      { name: 'Beatricie', id: '15406' },
      { name: 'Barry', id: '14955' },
    ],
    [
      { name: 'Barhi Barhavatamsaka', id: '15392' },
      { name: 'Bahriyahalaabidah', id: '13145' },
    ],
    [{ name: 'Ba', id: '14271' }],
  ],

  C: [
    [
      { name: 'Cable', id: '20430' },
      { name: 'Cacumattus  ', id: '18589' },
      { name: 'Cache ', id: '17133' },
    ],
    [
      { name: 'Cachet', id: '17453' },
      { name: 'Cace  ', id: '17151' },
      { name: 'Caddie ', id: '17011' },
    ],
    [
      { name: 'Cabail', id: '18331' },
      { name: 'Cabbrieli', id: '19032' },
      { name: 'Cable ', id: '20430' },
    ],
    [
      { name: 'Chandra', id: '16658' },
      { name: 'Chand', id: '16748' },
      { name: 'Cade ', id: '16708' },
      { name: 'Cara ', id: '16690' },
    ],
    [{ name: 'Caersewiella', id: '19931' }],
    [
      { name: 'Cab', id: '19341' },
      { name: 'Caj', id: '18754' },
      { name: 'Cal ', id: '17519' },
    ],
  ],

  D: [
    [
      { name: 'Dadhichi', id: '22655' },
      { name: 'Daeg', id: '21411' },
      { name: 'Dyunisa', id: '24498' },
      { name: 'Dyumna', id: '20927' },
    ],
    [
      { name: 'Dzifa ', id: '22893' },
      { name: 'Dwija ', id: '20609' },
      { name: 'Dyot ', id: '23677' },
      { name: 'Duua ', id: '23235' },
    ],
    [
      { name: 'Dyre  ', id: '24879' },
      { name: 'Dutchess ', id: '23720' },
      { name: 'Dai  ', id: '20918' },
    ],
    [
      { name: 'Das', id: '23321' },
      { name: 'Daffodil', id: '21250' },
    ],
    [{ name: 'Daithyakulantaka ', id: '22007' }],
    [{ name: 'Da', id: '22571' }],
  ],

  E: [
    [
      { name: 'Ealda', id: '25949' },
      { name: 'Easharjot', id: '26461' },
      { name: 'Eashana', id: '25849' },
      { name: 'Easharpreet', id: '26445' },
    ],
    [
      { name: 'Eadie', id: '25240' },
      { name: 'Eabae', id: '25539' },
      { name: 'Eadwina', id: '25277' },
    ],
    [
      { name: 'Eabbe', id: '26516' },
      { name: 'Eachann ', id: '26962' },
      { name: 'Eadaion', id: '26047' },
      { name: 'Eadberth', id: '27080' },
    ],
    [
      { name: 'Eastan', id: '26107' },
      { name: 'Emery', id: '24962' },
    ],
    [
      { name: 'Easharpreet', id: '26445' },
      { name: 'Eathellreda', id: '27357' },
      { name: 'Ebubechukwu', id: '27031' },
    ],
    [
      { name: 'Ea', id: '26318' },
      { name: 'Ed', id: '25406' },
    ],
  ],

  F: [
    [
      { name: "Fa'iqa", id: '28977' },
      { name: 'Faghyar', id: '28854' },
      { name: 'Fulvia', id: '28455' },
    ],
    [
      { name: 'Faalgunee', id: '28370' },
      { name: 'Fae', id: '29548' },
    ],
    [
      { name: 'Fabius', id: '28404' },
      { name: 'Fabrizia', id: '29516' },
      { name: 'Faddei', id: '28712' },
    ],
    [{ name: 'Fai', id: '27727' }],
    [{ name: 'Fakhruddawlah', id: '28937' }],
    [
      { name: 'Fu', id: '27939' },
      { name: 'Fa ', id: '27807' },
    ],
  ],

  G: [
    [
      { name: 'Gabrian', id: '29750' },
      { name: 'Gae', id: '32925' },
      { name: 'Gaetano', id: '32167' },
      { name: 'Gyaan', id: '29995' },
    ],
    [
      { name: 'Gajal', id: '31134' },
      { name: 'Gage', id: '29872' },
      { name: 'Gaiana ', id: '32954' },
    ],
    [
      { name: 'Gaihom', id: '32306' },
      { name: 'Gainell', id: '32980' },
      { name: 'Gusta', id: '32984' },
    ],
    [],
    [{ name: 'Gaganavihaaree', id: '30233' }],
    [{ name: 'Ga', id: '31195' }],
  ],

  H: [
    [
      { name: 'Habsana', id: '35300' },
      { name: 'Hymen', id: '34436' },
      { name: 'Haasini', id: '33259' },
      { name: 'Husn', id: '35929' },
    ],
    [
      { name: 'Hab', id: '35366' },
      { name: 'Haisam', id: '36421' },
      { name: 'Hunu', id: '33613' },
    ],
    [
      { name: 'Hunfredo', id: '34309' },
      { name: 'Hughetta', id: '34567' },
      { name: 'Haddon', id: '34001' },
    ],
    [
      { name: 'Haifa hayfa', id: '35388' },
      { name: 'Harley', id: '33200' },
    ],
    [{ name: 'Harimarkatamarkata', id: '34905' }],
    [{ name: 'Ha ', id: '33926' }],
  ],

  I: [
    [
      { name: 'Ibadat', id: '37145' },
      { name: 'Ik Onkar', id: '37189' },
      { name: 'Ikshit', id: '36833' },
    ],
    [
      { name: 'Ianira', id: '36954' },
      { name: 'Iara', id: '36810' },
      { name: 'Iavor', id: '37311' },
    ],
    [
      { name: 'Idowu', id: '37000' },
      { name: 'Inina', id: '36911' },
      { name: 'Inika ', id: '36809' },
    ],
    [
      { name: 'I.e. hosaamud', id: '37622' },
      { name: 'Inder', id: '37192' },
    ],
    [{ name: 'Igitioluwotilaiye ', id: '36994' }],
    [
      { name: 'Im ', id: '37476' },
      { name: 'In', id: '37251' },
    ],
  ],

  J: [
    [
      { name: 'Jaganmayi', id: '39644' },
      { name: 'Jagara', id: '41008' },
      { name: 'Jagrit', id: '39995' },
      { name: 'Jagravi', id: '38628' },
    ],
    [
      { name: 'Jah', id: '39697' },
      { name: 'Jisha', id: '37651' },
      { name: 'Jiana', id: '37653' },
    ],
    [
      { name: 'Jason', id: '39996' },
      { name: 'Jesus', id: '37949' },
    ],
    [{ name: 'Jo', id: '37923' }],
    [{ name: 'Jyothirmaayee', id: '39602' }],
    [
      { name: 'Jy', id: '40492' },
      { name: 'Ju', id: '38058' },
    ],
  ],

  K: [
    [
      { name: 'Kaashvi ', id: '41450' },
      { name: 'Kael ', id: '41988' },
      { name: 'Kaie', id: '45111' },
      { name: 'Kaina ', id: '41446' },
    ],
    [
      { name: 'Kaanishik  ', id: '42085' },
      { name: 'Kayra', id: '41403' },
      { name: 'Kiyansh', id: '41402' },
    ],
    [{ name: 'Kaapro', id: '45028' }],
    [
      { name: 'Kip', id: '46151' },
      { name: 'Kit ', id: '45947' },
    ],
    [{ name: 'Kaanchanadhwaja', id: '45358' }],
    [],
  ],

  L: [
    [
      { name: 'Laher  ', id: '47686' },
      { name: 'Lavanika', id: '46745' },
      { name: 'Lavnish', id: '46520' },
      { name: 'Lishanth', id: '46447' },
    ],
    [
      { name: 'Laher  ', id: '47686' },
      { name: 'Laghu', id: '47514' },
      { name: 'Leisha', id: '46448' },
    ],
    [{ name: 'Laban', id: '46771' }],
    [
      { name: 'Lane', id: '48885' },
      { name: 'Link', id: '48444' },
    ],
    [{ name: 'Langit Humasa', id: '47800' }],
    [
      { name: 'La', id: '47739' },
      { name: 'Li', id: '46690' },
      { name: 'Lu', id: '46947' },
    ],
  ],

  M: [
    [
      { name: 'Miraya', id: '49434' },
      { name: 'Medhansh', id: '49437' },
      { name: 'Manasvi', id: '49438' },
      { name: 'Mishita', id: '49439' },
    ],
    [
      { name: 'Misha', id: '49435' },
      { name: 'Mishika ', id: '49431' },
      { name: 'Mayra', id: '49432' },
    ],
    [],
    [{ name: 'Mai ', id: '55183' }],
    [{ name: 'Madhukaitabhahantri ', id: '51353' }],
    [
      { name: 'Ma', id: '51812' },
      { name: 'Mia', id: '49639' },
    ],
  ],

  N: [
    [
      { name: 'Niva', id: '55599' },
      { name: 'Nysa', id: '55602' },
    ],
    [
      { name: 'Niya', id: '55596' },
      { name: 'Nirved', id: '55594' },
      { name: 'Niva', id: '55599' },
    ],
    [
      { name: 'Nathan', id: '56538' },
      { name: 'Nathaniel', id: '57929' },
    ],
    [
      { name: 'Noah', id: '55683' },
      { name: 'Nora', id: '55703' },
    ],
    [{ name: 'Navanit Viliptanga', id: '58088' }],
    [
      { name: 'Nu', id: '57629' },
      { name: 'Nathaniel', id: '57929' },
    ],
  ],

  O: [
    [
      { name: 'Ojas', id: '59396' },
      { name: 'Ojasvi', id: '59397' },
      { name: 'Omysha', id: '59398' },
      { name: 'Oadira', id: '60265' },
    ],
    [
      { name: 'Oli', id: '59576' },
      { name: 'Obie', id: '59602' },
      { name: 'Odi ', id: '59708' },
    ],
    [{ name: 'Obed', id: '59575' }],
    [
      { name: 'Oke', id: '59460' },
      { name: 'Otte', id: '59851' },
    ],
    [{ name: 'Obatotosinloluwa ', id: '59984' }],
    [{ name: 'Om', id: '59402' }],
  ],

  P: [
    [
      { name: 'Parin', id: '60572' },
      { name: 'Prishanka', id: '60568' },
      { name: 'Pavani', id: '60571' },
      { name: 'Pranil', id: '60575' },
      { name: 'Praanvi', id: '60574' },
    ],
    [
      { name: 'Pradanya', id: '61827' },
      { name: 'Pranshi', id: '60537' },
      { name: 'Pranit', id: '60544' },
    ],
    [],
    [
      { name: 'Parker', id: '64241' },
      { name: 'Padma', id: '62737' },
    ],
    [{ name: 'Panchabhootatmika', id: '63005' }],
    [
      { name: 'Pav', id: '63360' },
      { name: 'Peg ', id: '63911' },
    ],
  ],

  Q: [
    [
      { name: 'Quin', id: '64547' },
      { name: 'Quim', id: '64509' },
      { name: 'Qays', id: '64587' },
    ],
    [
      { name: 'Qari', id: '64350' },
      { name: 'Qawi ', id: '64367' },
    ],
    [{ name: 'Quenna', id: '64398' }],
    [{ name: 'Qasim', id: '64575' }],
    [{ name: 'Quenataucus', id: '64450' }],
    [
      { name: 'Qi', id: '64286' },
      { name: 'Qu', id: '64426' },
    ],
  ],

  R: [
    [
      { name: 'Rithav', id: '64676' },
      { name: 'Rutvik', id: '64682' },
      { name: 'Rajvi', id: '64683' },
      { name: 'Riyyan', id: '64684' },
      { name: 'Rigvedita', id: '64690' },
    ],
    [
      { name: 'Riona', id: '64685' },
      { name: 'Rutvi', id: '64601' },
      { name: 'Rithul ', id: '64953' },
    ],
    [{ name: 'Rabbi ', id: '66951' }],
    [
      { name: 'Ryan', id: '64661' },
      { name: 'Ruby', id: '66767' },
    ],
    [{ name: 'Rakshavanara Sangathine ', id: '66738' }],
    [
      { name: 'Ri', id: '67327' },
      { name: 'Ru', id: '64884' },
    ],
  ],
  S: [
    [
      { name: 'Saanvi', id: '68777' },
      { name: 'Sharvil', id: '68779' },
      { name: 'Shanaya', id: '68780' },
      { name: 'Shreenika ', id: '68781' },
      { name: 'Shreyanvi ', id: '68797' },
    ],
    [
      { name: 'Siara', id: '68785' },
      { name: 'Sriansh', id: '68776' },
      { name: 'Sathvik', id: '68783' },
    ],
    [{ name: 'Salah ', id: '70191' }],
    [
      { name: 'Smith', id: '77459' },
      { name: 'Sky', id: '69898' },
      { name: 'Saint', id: '75625' },
    ],
    [{ name: 'Sacchidananda Vigraha ', id: '73920' }],
    [
      { name: 'Su ', id: '71006' },
      { name: 'Si', id: '77581' },
    ],
  ],
  T: [
    [
      { name: 'Takshvi', id: '77783' },
      { name: 'Tanvi', id: '77786' },
      { name: 'Tishya', id: '77787' },
      { name: 'Tanishka', id: '77789' },
    ],
    [
      { name: 'Tanush', id: '77784' },
      { name: 'Taavi', id: '80812' },
      { name: 'Taksh', id: '77788' },
    ],
    [{ name: 'Tahan ', id: '77904' }],
    [
      { name: 'Thomas', id: '77911' },
      { name: 'Terrence', id: '78097' },
    ],
    [
      { name: 'Tajammulhusain', id: '79672' },
      { name: 'Tatvagyanaprada', id: '78707' },
    ],
    [
      { name: 'Ti', id: '78150' },
      { name: 'Tu', id: '78472' },
    ],
  ],
  U: [
    [
      { name: 'Ubay', id: '81547' },
      { name: 'Uchit', id: '81344' },
      { name: 'Udarsh ', id: '81396' },
    ],
    [
      { name: 'Udgita', id: '81443' },
      { name: 'Udita', id: '81288' },
      { name: 'Udyam', id: '81785' },
    ],
    [],
    [],
    [{ name: 'Umdatuddawlah', id: '81736' }],
    [],
  ],
  V: [
    [
      { name: 'Vedika', id: '81897' },
      { name: 'Viraj', id: '81893' },
      { name: 'Viaan', id: '81894' },
    ],
    [
      { name: 'Vihaan', id: '81895' },
      { name: 'Ved', id: '81898' },
      { name: 'Viransh', id: '81899' },
    ],
    [{ name: 'Vianca', id: '81979' }],
    [{ name: 'Vin', id: '83469' }],
    [{ name: 'Vardhimainakapujita', id: '82671' }],
    [{ name: 'Var', id: '83550' }],
  ],

  W: [
    [
      { name: 'Waafiyah', id: '83685' },
      { name: 'Waamil', id: '83731' },
      { name: 'Waitherero', id: '83678' },
    ],
    [
      { name: 'Wafa', id: '83837' },
      { name: 'Wagma', id: '83662' },
      { name: 'Wyatt', id: '83627' },
    ],
    [
      { name: 'Woong', id: '83693' },
      { name: 'Woelinam', id: '83794' },
      { name: 'Wenceslaus', id: '83741' },
    ],
    [{ name: 'Walden', id: '83698' }],
    [{ name: 'Wahiduzzaman', id: '83767' }],
    [
      { name: 'Waf', id: '83870' },
      { name: 'Wad ', id: 'Wad ' },
    ],
  ],
  X: [
    [
      { name: 'Xoan', id: '32' },
      { name: 'Xylia', id: '4' },
      { name: 'Xorlali ', id: '6' },
    ],
    [
      { name: 'Xena ', id: '3' },
      { name: 'Xhim', id: '28' },
      { name: 'Xoti', id: '12' },
    ],
    [
      { name: 'Xesas', id: '23' },
      { name: 'Xoana', id: '7' },
      { name: 'Xoese', id: '24' },
    ],
    [],
    [
      { name: 'Xantheus', id: '14' },
      { name: 'Xinavane', id: '16' },
    ],
    [
      { name: 'Xena', id: '1' },
      { name: 'Xoti', id: '12' },
    ],
  ],
  Y: [
    [
      { name: 'Ywain', id: '84300' },
      { name: 'Yugma', id: '84365' },
      { name: 'Yugank', id: '84209' },
    ],
    [
      { name: 'Yugin', id: '84126' },
      { name: 'Yukasri', id: '84247' },
      { name: 'Yumi', id: '84132' },
    ],
    [
      { name: 'Yvettia', id: '84403' },
      { name: 'Yule', id: '84629' },
      { name: 'Yun Hee', id: '84335' },
    ],
    [
      { name: 'Yves', id: '84638' },
      { name: 'Yule', id: '84629' },
      { name: 'Young', id: '84488' },
    ],
    [{ name: 'Yaa', id: '84298' }],
    [{ name: 'Yuj', id: '84246' }],
  ],
  Z: [
    [
      { name: 'Zafreen', id: '84811' },
      { name: 'Zaeemah', id: '85007' },
      { name: 'Zahrun', id: '84845' },
    ],
    [
      { name: 'Zaaei', id: '84772' },
      { name: 'Zafira', id: '84738' },
      { name: 'Zaia', id: '84753' },
    ],
    [
      { name: 'Zane', id: '84652' },
      { name: 'Zantina', id: '85139' },
      { name: 'Zeferino', id: '84936' },
    ],
    [],
    [{ name: 'Zaheeruddawlah', id: '85168' }],
    [{ name: 'Za', id: '85105' }],
    ,
  ],
};
